//@ts-nocheck
/**
 * src/routes/routes.tsx
 * ---------------------------------------------------------------------------
 * Central Router composer.
 *
 * Route sections are defined in:
 *   - sections/auth.tsx       (login)
 *   - sections/userRoutes.tsx (public / user pages)
 *   - sections/adminRoutes.tsx (CMS / admin pages)
 *
 * This file assembles them via useRoutes() — all paths are preserved exactly.
 */
import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { paths } from './paths';

// ── Route sections ─────────────────────────────────────────────────────────
import { authRoutes } from './sections/auth';
import { userRoutes } from './sections/userRoutes';
import { adminRoutes } from './sections/adminRoutes';

export default function Router({ user, immersive, browseWithoutLogin, isConfigLoading, isLoading }: any) {
  return useRoutes([
    // User / public routes (includes GuestGuard + UserLayout + admin nested)
    ...userRoutes({ immersive, browseWithoutLogin, isConfigLoading, user, isLoading }),

    // Auth routes (login page — public, no guard)
    ...authRoutes,

    // Catch-all
    { path: '*', element: <Navigate to={paths.page404} replace /> },
  ]);
}
